import type { AdminViewDefinition } from "../../components/admin-components.js";

export const auditAdminViews: AdminViewDefinition[] = [auditExplorerView()];

function auditExplorerView(): AdminViewDefinition {
  return {
    id: "audit-explorer",
    navId: "audit",
    title: "Audit Explorer",
    description: "Search immutable store, administrator, platform, and automated-system actions.",
    actions: [],
  };
}
